"use strict";

module.exports = function (name) {
  if (!name) return name;
  name = name.split('__');
  name.shift();
  return name.join('__').split('@@@').join('.');
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/methods/get-name.js
// module id = 896
// module chunks = 0